<div class="mb-3">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  <mat-list class="mat-list-dynamic">
    @for (item of problemList(); track ($index + item.id + item.problem); let i = $index) {
      <mat-list-item [style.color]="control().valueColour">
        @if (item.comment) {
          <span matListItemLine>{{ i + 1 }} - {{ item.problem }}</span>
        }
        @if (!item.comment) {
          <span>{{ i + 1 }} - {{ item.problem }}</span>
        }
        @if (item.comment) {
          <span matListItemLine>{{ item.comment }}</span>
        }
      </mat-list-item>
    }
  </mat-list>
</div>
